import './style.scss';
import React, { useRef } from 'react';
import { AssistantRuntimeProvider, CompositeAttachmentAdapter, useRemoteThreadListRuntime } from '@assistant-ui/react';
import { useChatRuntime, AssistantChatTransport } from '@assistant-ui/ai-sdk';
import { useAppSelector } from 'index';
import { useInitialMessage } from '../hooks/initialMessage';
import { ThreadList } from '../components/assistant-ui/thread-list';
import { Thread } from '../components/assistant-ui/thread';
import DocumentAttachmentAdapter from '../components/assistant-ui/DocumentAttachmentAdapter';
import { createThreadListAdapter } from '../components/assistant-ui/thread-adapter';

interface AiChatProps {
  token: string;
  data: string;
  dataPointId?: string;
}

export default function Chat(props: AiChatProps) {
  const { token, dataPointId, data } = props;
  // const dispatch = useDispatch();
  const settings = useAppSelector(state => state.clientPersist);

  const url = `${location.protocol}//${location.hostname}`;

  /* const cloud = React.useRef<AssistantCloud>(
    new AssistantCloud({
      baseUrl: 'https://proj-0bbuaojf22zc.assistant-api.com',
      authToken: () =>
        fetch(`${url}:3000/auth-cloud`, {
          method: 'POST',
          headers: {
            'Authorization': `${token}`,
            'tenant': `${settings.instance}`,
            'WorkspaceId': `${settings.instance}-${settings.user_id}${dataPointId ? `-${dataPointId}` : ''}`,
            'key': 'ASSISTANT_ASK_AI_API_KEY'
          }
        }).then((r) =>
          r.text(),
        ),
    })
  );
  const runtime = useChatRuntime({
    transport: new AssistantChatTransport({
      api: `${url}:3000/analyze`,
      headers: {
        'Authorization': `${token}`,
        'tenant': `${settings.instance}`
      },
      credentials: 'omit',
    }),
    adapters: {
      attachments: new CompositeAttachmentAdapter([
        new DocumentAttachmentAdapter()
      ])
    },
    cloud: cloud.current
  });*/
  const threadListAdapter = useRef(createThreadListAdapter({
    'Authorization': `${token}`,
    'tenant': `${settings.instance}`,
    'userId': `${settings.user_id}`,
    'WorkspaceId': `${settings.instance}-${settings.user_id}${dataPointId ? `-${dataPointId}` : ''}`,
  }));

  const runtime = useRemoteThreadListRuntime({
    runtimeHook: () => useChatRuntime({
      transport: new AssistantChatTransport({
        api: `${url}:3000/analyze`,
        headers: {
          'Authorization': `${token}`,
          'tenant': `${settings.instance}`,
          'userId': `${settings.user_id}`
        },
        credentials: 'omit',
      }),
      adapters: {
        attachments: new CompositeAttachmentAdapter([
          new DocumentAttachmentAdapter()
        ])
      },
    }),
    adapter: threadListAdapter.current,
  });
  if (data) {
    useInitialMessage(runtime, data);
  }

  return (
    <AssistantRuntimeProvider runtime={runtime}>
      <div className={'row chat-row'}>
        <ThreadList />
        <Thread />
      </div>
    </AssistantRuntimeProvider>
  );
}
